import { make } from 'vuex-pathify';
import { EventService } from '@/services/event';
import { Event } from '@/models/Event';
import { errorCatch } from '../utils';

// acounts
import { accountService } from './accounts';

const eventService = new EventService();
type Events = Event;
export const state = {
  options: {},
  events: [] as Events[],
  eventInstance: {} as Events,
  loading: false,
  currentEvent:
    localStorage.getItem('current__event') || accountService.events[0] || null,
  error: {},
  demoEvent: {
    id: 'demo-project-id',
    name: 'Use demo project',
    address: {
      country: {
        name: 'Canada'
      }
    }
  } as Event
};

export const mutations = {
  REMOVE_EVENT(state: any, payload: any) {
    const index = state.events.findIndex(
      (event: Event) => event.id === payload
    );
    state.events.splice(index, 1);
  },
  ADD_EVENT(state: any, payload: any) {
    state.events.push(payload);
  },
  UPDATE_EVENT(state: any, payload: any) {
    const index = state.events.findIndex(
      (event: Event) => event.id === payload.id
    );
    state.events.splice(index, 1, payload);
  },
  ...make.mutations(state),
  SET_ERROR(state: any, error: any) {
    errorCatch(state, error);
  },
  CLEAR_ERROR(state: any) {
    state.error = {};
  },
  SET_CURRENT_EVENT: (state: any, payload: string) =>
    localStorage.setItem('current__event', payload)
};

export const actions = {
  clearError: ({ commit }: any) => commit('CLEAR_ERROR'),
  createEvent: async ({ commit, dispatch }: any, payload: Events) => {
    dispatch('clearError');

    commit('SET_LOADING', true);

    return await new Promise((resolve, reject) => {
      eventService
        .createEvent(payload)
        .then(event => {
          commit('ADD_EVENT', event);
          resolve(event);
        })
        .catch(err => {
          commit('SET_ERROR', err);

          // error place holder commit('error/SET_ERROR', error, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  fetchEvents: async ({ commit, dispatch }: any) => {
    dispatch('clearError');

    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      eventService
        .fetchEvents()
        .then(events => {
          commit('SET_EVENTS', events);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // // error place holder commit('error/SET_ERROR', error, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  fetchEvent: async ({ commit, state, dispatch }: any, payload: string) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      eventService
        .getEvent(payload)
        .then(event => {
          const index = state.events.findIndex((e: Events) => e.id === payload);
          if (index === -1) {
            commit('ADD_EVENT', event);
          } else {
            commit('UPDATE_EVENT', event);
          }
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  updateEvent: async ({ commit, dispatch }: any, payload: Events) => {
    dispatch('clearError');

    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      eventService
        .updateEvent(payload.id, payload)
        .then(res => {
          commit('UPDATE_EVENT', res);
          resolve();
          dispatch(
            'snackbar/createSnack',
            {
              color: 'primary',
              type: 'edit',
              href: false,
              msg: `Edited: ${res.name}`,
              text: 'Close',
              to: false,
              timeout: 6000,
              action: () => {}
            },
            { root: true }
          );
        })
        .catch(err => {
          commit('SET_ERROR', err);

          // error place holder commit('error/SET_ERROR', error, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  deleteEvent: async ({ commit, dispatch }: any, payload: string) => {
    dispatch('clearError');

    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      eventService
        .deleteEvent(payload)
        .then(() => {
          commit('REMOVE_EVENT', payload);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // error place holder commit('error/SET_ERROR', error, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  optionsEvent: async ({ commit, dispatch }: any) => {
    console.log('options callback');

    dispatch('clearError');

    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      eventService
        .optionsListEvent()
        .then(res => {
          commit('SET_OPTIONS', res.actions.POST);
          console.log(res);

          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          console.log(err);

          // error place holder commit('error/SET_ERROR', error, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  }
};

export const getters = {
  getEventLoading: (state: any) => state.loading,
  getEventList: (state: any) => state.events,
  getEventInstance: (state: any) => state.eventInstance,
  getEventOptions: (state: any) => state.options,
  getEventError: (state: any) => state.error,
  getCurrentEvent: (state: any) => state.currentEvent,
  getEventById: (state: any) => (id: string) => {
    return state.events.find((event: Event) => event.id === id);
  }
};
